// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*,*:before,*:after{box-sizing:inherit}html{font-size:62.5%}body{letter-spacing:normal}fieldset{border:0;margin:0;padding:0}ul,ol{margin-top:0}\n", ""]);
// Exports
module.exports = exports;
